import PageLoading from "../../../components/PageLoading";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
import Config from "../../../Config";
import { useDispatch } from "react-redux";
import { ActionType } from "../../../store/ActionType";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useAppCookies } from "../../../util/useAppCookies";

const LogoutPage = () => {

    const dispatch = useDispatch();

    const history = useHistory();

    const { clearUser } = useAppCookies();

    useEffect(async () => {

        await clearUser();

        dispatch({
            type: ActionType.LOGOUT
        });


    }, []);

    return (
        <PageLoading />
    )
}

export default LogoutPage;
